import { render, staticRenderFns } from "./MemberStatistics.vue?vue&type=template&id=1c2f98ab"
import script from "./MemberStatistics.vue?vue&type=script&lang=js"
export * from "./MemberStatistics.vue?vue&type=script&lang=js"
import style0 from "./MemberStatistics.vue?vue&type=style&index=0&id=1c2f98ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports